import SkipNextIcon from "@mui/icons-material/SkipNext";
import { Button, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface ParkNextButtonProps {
  onClick: () => void;
  disabled: boolean;
  disabledMessage?: string;
  compact?: boolean;
  inGroup?: boolean;
  fullWidth?: boolean;
}

export const ParkNextButton: React.FC<ParkNextButtonProps> = ({
  onClick,
  disabled,
  disabledMessage,
  compact = false,
  fullWidth = false,
}) => {
  const { t } = useTranslation();
  const button = compact ? (
    <IconButton
      color="primary"
      onClick={onClick}
      disabled={disabled}
      size="small"
    >
      <SkipNextIcon />
    </IconButton>
  ) : (
    <Button
      variant="outlined"
      color="primary"
      onClick={onClick}
      startIcon={<SkipNextIcon />}
      fullWidth={fullWidth}
      disabled={disabled}
      size="small"
    >
      {t('screens.ramp.autoPark.parkNextButton.label')}
    </Button>
  );

  const defaultDisabledMessage = t('screens.ramp.autoPark.parkNextButton.disabledMessage');
  const tooltipTitle = compact
    ? t('screens.ramp.autoPark.parkNextButton.tooltip')
    : disabled
    ? (disabledMessage || defaultDisabledMessage)
    : "";

  if (disabled || compact) {
    return (
      <Tooltip title={tooltipTitle}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};
